import "./App.css";
import "./Components/mainstyle/mainstyle.css";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Mainadminpage from "./Components/admin/mainadminpage/mainadminpage";
import ProtectedRoute from "./Components/protect hooks/ProtectedRouteHook";
import Login from "./Components/form/login/login";
import Internet from "./Components/internet/internet";
import Layout from "./Components/Utility/layout/layout";
import ProtectedRouteHook from "./Components/protect hooks/protectLogic";
import Register from "./Components/form/register/register";
import "bootstrap/dist/css/bootstrap.min.css";
import Notfound from "./Components/notfound/notfound";
import Notifications from "./Components/notifications/notifications";
import MainUserpage from "./Components/user/mainuserpage/mainuserpage";
import Maindata from "./Components/user/maindata/main/main";
import Adminmanage from "./Components/admin/adminmanage/adminmanage";
import Emails from "./Components/admin/emails/emails";
import Subscribepackage from "./Components/admin/subscribepackage/subscribepackage";
import NotificationsAdmin from "./Components/admin/notification/notification";
import Payment from "./Components/user/sub/main/main";
import Howwork from "./Components/user/howwork/howwork";
import Helpuser from "./Components/user/help/help";
import MainEmp from "./Components/user/mainemployee/main/main";
import Hodoremp from "./Components/user/hodoremp/main/main";
import Hodoradmin from "./Components/user/hodoradmin/main/main";
import Salaryemp from "./Components/user/salaryemp/main/main";
import Managereq from "./Components/user/Holiday/main/main";
import Manageagzaa from "./Components/user/AdminRequest/main/main";
import Privacy from "./Components/form/privacy/privacy";
import MainUserSub from "./Components/admin/usersubscrip/main/main";
import Forget from "./Components/form/forget/forget";
import MainUser from "./Components/admin/usermanage/main/main";
function App() {
  const [isUser, isAdmin, userData, , isEditor, isEmp] = ProtectedRouteHook();
  return (
    <>
      <BrowserRouter>
        <Layout
          userData={userData}
          isUser={isUser}
          isAdmin={isAdmin}
          isEmp={isEmp}>
          {navigator.onLine === false ? (
            <Internet />
          ) : (
            <Routes>
              <Route
                path="/login"
                element={<Login isUser={isUser} isAdmin={isAdmin} />}
              />
                {isUser || isAdmin ? null : (
                <>
                  <Route
                    path="/login"
                    element={<Login isUser={isUser} isAdmin={isAdmin} />}
                  />

                  <Route index element={<Register />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/forget" element={<Forget />} />
                </>
              )}

              <Route path="/Privacy" element={<Privacy />} />
              <Route index element={<Register />} />
              <Route path="/user/hodoremp" element={<Hodoremp  userData={userData}/>} />
              <Route element={<ProtectedRoute auth={isEmp} />}>
                <Route path="/user/hodoremp" element={<Hodoremp  userData={userData}/>} />
                {/* <Route path="/user/notifications" element={<Notifications />} /> */}
              </Route>
              <Route element={<ProtectedRoute auth={isUser} />}>
              <Route path="/user/hodoremp" element={<Hodoremp  userData={userData}/>} />
                <Route path="/user/mainuserpage" element={<MainUserpage  />} />
                <Route path="/user/manageholiday" element={<Managereq userData={userData}  />} />
                <Route path="/user/managerequest" element={<Manageagzaa  userData={userData} />} />

                <Route path="/user/mainemployee" element={<MainEmp userData={userData} />} />
                <Route path="/user/hodoradmin" element={<Hodoradmin  userData={userData} />} />
                <Route path="/user/salaryemp" element={<Salaryemp  userData={userData}/>} />
                <Route path="/user/data" element={<Maindata userData={userData} />} />
                <Route path="/user/howwork" element={<Howwork />} />
                <Route
                  path="/user/help"
                  element={<Helpuser userData={userData} />}
                />
                <Route path="/user/sub" element={<Payment  userData={userData}/>} />
                <Route path="/user/notifications" element={<Notifications userData={userData} />} />
                {/* <Route path="/user/supuser" element={<Mainsubuser />} /> */}
              </Route>
          <Route element={<ProtectedRoute auth={isAdmin} />}>
                <Route
                  path="/admin"
                  element={
                    <Mainadminpage userData={userData} isAdmin={isAdmin} />
                  }
                />
                <Route path="/admin/adminmanage" element={<Adminmanage />} />
                <Route path="/admin/emails" element={<Emails />} />
                <Route
                  path="/admin/subscribepackage"
                  element={<Subscribepackage />}
                />
                <Route path="/admin/usermanagement" element={<MainUser />} />
                <Route path="/admin/usersubscribe" element={<MainUserSub />} />

                <Route
                  path="/admin/notifications"
                  element={<NotificationsAdmin />}
                />
              </Route>
              <Route element={<ProtectedRoute auth={isEditor} />}>
                <Route
                  path="/editor"
                  element={
                    <Mainadminpage userData={userData} isAdmin={isAdmin} />
                  }
                />
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "إضافة باقة" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/subscribepackage"}
                          element={<Subscribepackage />}
                        />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "بيانات المستخدمين" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/usermanagement"}
                          element={<MainUser />}
                        />
                      ) : null
                    )
                  : null}
                        
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "بيانات المشتركين" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/usersubscribe"}
                          element={<MainUserSub />}
                        />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "الايميلات" &&
                      claim.IsSelected === true ? (
                        <Route path={"/editor/emails"} element={<Emails />} />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "الاشعارات" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/notifications"}
                          element={<NotificationsAdmin />}
                        />
                      ) : null
                    )
                  : null}
              </Route>
              <Route path="404" element={<Notfound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          )}
        </Layout>
      </BrowserRouter>
    </>
  );
}

export default App;
